import { motion } from 'framer-motion';
import { FaWhatsapp, FaInstagram, FaYoutube, FaEnvelope } from 'react-icons/fa';

/**
 * Minimal 3-column footer with social links and legal modals.
 */
export default function Footer({ onAbout, onContact, onPrivacy, onTerms, onAuth, onFeedback }) {
  return (
    <motion.footer
      className="site-footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <div className="footer-grid">
        {/* Brand */}
        <div className="footer-col">
          <h4 className="footer-brand">YELKEN</h4>
          <p className="footer-tagline">Disiplinli bir gelecek için buradayız.</p>
          <p className="footer-address">
            Kızılırmak Mah. 1443 Cad. No: 25-B/8<br />
            1071 Plaza Çankaya / Ankara
          </p>
        </div>

        {/* Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Bağlantılar</h4>
          <button className="footer-link" onClick={onAbout}>Hakkımızda</button>
          <button className="footer-link" onClick={onContact}>İletişim</button>
          <button className="footer-link" onClick={onPrivacy}>Gizlilik Politikası</button>
          <button className="footer-link" onClick={onTerms}>Şartlar ve Koşullar</button>
          <button className="footer-link" onClick={onFeedback} style={{ color: 'var(--accent-primary)' }}>🐞 Hata Bildir / Öneri</button>
        </div>

        {/* Social */}
        <div className="footer-col">
          <h4 className="footer-heading">Sosyal</h4>
          <div className="footer-socials">
            <a href="https://wa.me/+905442256334" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="WhatsApp">
              <FaWhatsapp size={18} />
            </a>
            <a href="https://www.instagram.com/yelken.pro/" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="Instagram">
              <FaInstagram size={18} />
            </a>
            <a href="https://www.youtube.com/@emrenefsien" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="YouTube">
              <FaYoutube size={18} />
            </a>
            <a href="mailto:destek@yelken.pro" className="footer-social" aria-label="E-posta">
              <FaEnvelope size={18} />
            </a>
          </div>
          <a href="tel:+905442256334" className="footer-phone">+90 544 225 6334</a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Yelken. Tüm hakları saklıdır.</span>
      </div>
    </motion.footer>
  );
}
